import React__default from 'react';
import cn from 'classnames';
import styles from 'ui-components/Wrapper.scss';

var Wrapper = function Wrapper(_ref) {
  var _cn;
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "" : _ref$variant,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, className, (_cn = {}, _cn[styles[variant && "block__" + variant]] = Boolean(variant), _cn))
  }, children);
};

export { Wrapper };
//# sourceMappingURL=index.js.map
